<template>
    <el-table 
        size="small"
        style="height: 100%"
        header-cell-class-name="charts-table-header"
        v-if="columns?.length > 0 && data?.length>0"
        :border="true"
        :data="displayData">
        <el-table-column show-overflow-tooltip
            v-for="column in columns"
            :key="column.key"
            :label="column.label"
            :prop="column.key">
        </el-table-column>
    </el-table>
</template>
<style>
.charts-table-header{
    background-color: var(--fill-color-3) !important;
}
</style>
<script>
import { chartColumnLabel, resolveChartDisplayRow } from '../display'

export default{
    props: ["widgets", "data", "additional", "fieldMeta"],
    data(){
         return{
         }
    },
    computed: {
        columns(){
            const columns = [];
            this.widgets.dimensions.forEach((dimension) => {
                columns.push({
                    label: chartColumnLabel(dimension),
                    key: dimension.Name,
                });
            });
            this.widgets.measures.forEach((measure) => {
                columns.push({
                    label: chartColumnLabel(measure),
                    key: measure.Name,
                });
            });
            return columns;
        },
        displayData(){
            return (this.data || []).map((row) => resolveChartDisplayRow(row, this.fieldMeta, this.additional));
        }
    },
    mounted(){

    }
}
</script>
